export default {
  // Basic operations
  ok: 'OK',
  cancel: 'Cancel',
  submit: 'Submit',
  save: 'Save',
  edit: 'Edit',
  delete: 'Delete',
  add: 'Add',
  create: 'Create',
  update: 'Update',
  close: 'Close',
  confirm: 'Confirm',
  reset: 'Reset',
  clear: 'Clear',
  search: 'Search',
  filter: 'Filter',
  refresh: 'Refresh',
  reload: 'Reload',
  download: 'Download',
  upload: 'Upload',
  export: 'Export',
  import: 'Import',
  preview: 'Preview',
  view: 'View',
  detail: 'Detail',
  change: 'Change',

  // Status messages
  success: 'Operation successful',
  failed: 'Operation failed',
  error: 'Error',
  warning: 'Warning',
  info: 'Information',
  loading: 'Loading...',
  saving: 'Saving...',
  submitting: 'Submitting...',
  processing: 'Processing...',

  // Success messages
  saveSuccess: 'Save successful',
  deleteSuccess: 'Delete successful',
  addSuccess: 'Add successful',
  updateSuccess: 'Update successful',
  uploadSuccess: 'Upload successful',
  downloadSuccess: 'Download successful',
  exportSuccess: 'Export successful',
  importSuccess: 'Import successful',

  // Error messages
  saveFailed: 'Save failed',
  deleteFailed: 'Delete failed',
  addFailed: 'Add failed',
  updateFailed: 'Update failed',
  uploadFailed: 'Upload failed',
  downloadFailed: 'Download failed',
  exportFailed: 'Export failed',
  importFailed: 'Import failed',

  // Confirmation messages
  deleteConfirm: 'Are you sure you want to delete?',
  saveConfirm: 'Are you sure you want to save?',
  resetConfirm: 'Are you sure you want to reset?',
  clearConfirm: 'Are you sure you want to clear?',

  // Form validation
  required: 'This field is required',
  pleaseInput: 'Please input',
  pleaseSelect: 'Please select',
  invalidFormat: 'Invalid format',

  // Data status
  noData: 'No data',
  noResult: 'No search results',
  dataEmpty: 'Data is empty',

  // General status
  enabled: 'Enabled',
  disabled: 'Disabled',
  active: 'Active',
  inactive: 'Inactive',
  online: 'Online',
  offline: 'Offline',

  // Operations
  action: 'Action',
  actions: 'Actions',
  operation: 'Operation',
  manage: 'Manage',
  setting: 'Setting',
  settings: 'Settings',
  config: 'Configuration',
  backHome: 'Back Home',
  uploading: 'Uploading...',

  // Time related
  today: 'Today',
  yesterday: 'Yesterday',
  tomorrow: 'Tomorrow',
  thisWeek: 'This Week',
  thisMonth: 'This Month',
  thisYear: 'This Year',

  // Pagination
  total: 'Total',
  items: 'items',
  page: 'Page',
  goTo: 'Go to',
  pageSize: 'per page',

  // Language related
  language: 'Language',
  chinese: '中文',
  english: 'English',
  switchLanguage: 'Switch Language',

  // Account related
  password: 'Password',
  username: 'Username',
  email: 'Email',
  phone: 'Phone',

  // Project related
  currentProject: 'Current Project',
  selectProject: 'Select Project',
  createProject: 'Create New Project',
  projectName: 'Project Name',
  projectCode: 'Project Code',
  projectDescription: 'Project Description',
  projectCreator: 'Creator',
  projectManager: 'Project Manager',
  pleaseInputProjectName: 'Please enter project name',
  pleaseInputProjectCode: 'Please enter project code',
  pleaseInputProjectDescription: 'Please enter project description',
  getUserInfoFailed: 'Failed to get user information, please log in again!',

  // Application title
  appTitle: 'AsPiCe Development System',

  // Problem severity / priority / status
  'severity.CRITICAL': 'Fatal',
  'severity.MAJOR': 'Severe',
  'severity.MEDIUM': 'General',
  'severity.MINOR': 'Minor',
  'priority.HIGHEST': 'Highest',
  'priority.HIGH': 'High',
  'priority.MEDIUM': 'Medium',
  'priority.LOW': 'Low',
  'problemStatus.CREATED': 'Created',
  'problemStatus.RESOLVING': 'Resolving',
  'problemStatus.MODIFICATION_REVIEW': 'Modification Review',
  'problemStatus.RESOLVED': 'Resolved',
  'problemStatus.SOLUTION_APPROVED': 'Regression Approved',
  'problemStatus.VERIFICATION_APPROVED': 'Verification Approved',
  'problemStatus.CLOSED': 'Closed',
  'discoverySource.REVIEW': 'Review',
  'discoverySource.QUALITY_CHECK': 'Quality Check',
  'discoverySource.TEST': 'Test',
  'discoverySource.ASSESSMENT': 'Certification Assessment',
  'discoverySource.OTHER': 'Other',
};
